import { groq } from "next-sanity";
import { seoFields } from "../partials/shared";

export const newsBySlugQuery = groq`*[_type == "newsPages" && slug.current == $slug][0] {
  title,
  description,
  publishedAt,
  image{
    ...,
    "lqip": asset->metadata.lqip
  },
  "slug": slug.current,
  newsType->{
    title,
    "slug":slug.current
  },
  duration,
  author->{
    name,
    catchphrase,
    image,
    avatar,
    role
  },
  "otherNews": *[_type=='newsPages' && slug.current != $slug] | order(publishedAt desc)[0...3]{
    "type":_type,
    title,
    publishedAt,
    description,
    duration,
    image{
      ...,
      "lqip": asset->metadata.lqip
    },
    thumbnail{
      ...,
      "lqip": asset->metadata.lqip
    },
    "slug": slug.current,
    newsType->{
      title
    }
  },
  content[]{
    ...,
    _type == 'video' => {
      ...,
      "videoData": muxVideo.asset->{
        "playbackId": playbackId,
        "aspectRatio": data.aspect_ratio
      },
    },
    _type == 'youtubeVideo' => {
      _type,
      _key,
      videoId,
      placeholderImage {
        ...,
        "lqip": asset->metadata.lqip
      },
      caption
    },
  },
  ${seoFields}
}`;

export const newsBySlugSeoQuery = groq`*[_type == "newsPages" && slug.current == $slug][0]{
	${seoFields}
}`;
